import React from 'react';

const Edit = ({ className = '', onClick = () => null }) => {
  return (
    <div className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='19'
        height='12'
        viewBox='0 0 19 12'
        fill='none'
      >
        <path
          d='M14.9293 5.52685C15.2666 5.18951 15.7242 5 16.2012 5C16.6783 5 17.1358 5.18951 17.4731 5.52685C17.8105 5.86419 18 6.32171 18 6.79878C18 7.27584 17.8105 7.73337 17.4731 8.07071L14.5696 11H12V8.43045L14.9293 5.52685Z'
          stroke='#161616'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M15 1H1M1 5H8M8 9H1'
          stroke='#161616'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </div>
  );
};

export default Edit;
